import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NewsList } from "../components/blocks/news-list";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";
import { BlockLink } from "../render/context";
/** The News & Events card grid, shared by the code-owned page and CMS block. */
export function NewsListView({ heading, body, viewAllLabel, viewAllHref, items, className, }) {
    return (_jsx("section", { className: cn("@container w-full bg-transparent", className), "aria-label": heading ? undefined : "Diality news releases", children: _jsxs("div", { className: "w-full px-[6.667cqw] @min-[701px]:px-[clamp(32px,7cqw,76px)] @min-[1101px]:px-[clamp(24px,10.694cqw,154px)]", children: [heading || body ? (_jsxs("header", { className: "mx-auto mb-10 flex max-w-[850px] flex-col items-center gap-3 text-center", children: [heading ? (_jsx("h2", { className: "font-display text-[clamp(48px,12cqw,64px)] font-light leading-[1.04] tracking-[-0.02em] text-brand-blue @min-[701px]:text-[64px]", children: heading })) : null, body ? (_jsx("p", { className: "max-w-[700px] text-lg font-light leading-[1.55] text-foreground @min-[701px]:text-xl", children: body })) : null] })) : null, _jsx(NewsList, { items: items, pagination: true }), viewAllHref ? (_jsx("div", { className: "mt-10 text-center", children: _jsx(Button, { asChild: true, variant: "outline", children: _jsx(BlockLink, { href: viewAllHref, children: viewAllLabel ?? "View all" }) }) })) : null] }) }));
}
export function NewsListBlock({ data }) {
    return _jsx(NewsListView, { ...data });
}
export function newsListFromBlock(block, _resolve) {
    const scalars = block.scalars ?? {};
    return {
        heading: scalars.heading || undefined,
        body: scalars.body || undefined,
        viewAllHref: scalars.viewAllHref || undefined,
        viewAllLabel: scalars.viewAllLabel || undefined,
        items: (block.repeats?.items ?? []).map((item) => ({
            key: item.id,
            title: item.scalars.title || "",
            href: item.scalars.href || undefined,
            date: item.scalars.date || undefined,
            source: item.scalars.source || undefined,
            category: item.scalars.category || undefined,
            summary: item.scalars.summary || undefined,
            readMoreHref: item.scalars.readMoreHref || undefined,
            readMoreLabel: item.scalars.readMoreLabel || undefined,
        })),
    };
}
export const newsListBlockEntry = {
    Component: NewsListBlock,
    fromBlock: newsListFromBlock,
};
//# sourceMappingURL=news-list.js.map